import { render, staticRenderFns } from "./ChildRoute.vue?vue&type=template&id=0bb49f94&scoped=true&"
import script from "./ChildRoute.vue?vue&type=script&lang=js&"
export * from "./ChildRoute.vue?vue&type=script&lang=js&"
import style0 from "./ChildRoute.vue?vue&type=style&index=0&id=0bb49f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb49f94",
  null
  
)

export default component.exports